import React, { forwardRef, Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Datetime from "react-datetime";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import Select from "react-select";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import {
  AddInvetory,
  AddToInventoryStockStoreWise,
  getBatchNumberByAllMedicine,
  getBatchNumberByMedicine,
  getBrachDetailsCountryCodeWise,
  getMedicaitionDataById,
  getmedicationdatabyid,
  searchMedicationForManualGrn,
  searchMedicationForSubProduct,
  updateMedication_old_data,
} from "../../../Listfunction";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import ReactDOM from "react-dom";
import NoMedicineAvailablePopup from "./noMedicineAvailable";
import ShowMultipleBatchesModal from "./showMultipleBatchesModal";

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

class addnewsubscriptionpackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: "",
      quantityError: null,
      unit_price: "",
      batch_no: "",
      unit_priceError: null,
      note: "STOCK APR 26",
      noteError: null,
      expiryDate: "",
      expiryDateError: null,
      medication: "",
      medicationError: null,
      _notificationSystem: null,
      cardHidden: true,
      value: "",
      name: "",
      quantity_typeError: null,
      quantity_type: "2",
      showPerBox: false,
      quantity_per_box: "0",
      quantity_per_boxError: null,
      receivable_date: "",
      is_goods_received: 1,
      previousQuantity: 0,
      barcodeValue: "",
      previousPrice: "",
      itemCode: "",
      coppied: false,
      medicineValue: "",
      disableSubmitButton: false,
      storeId: "",
      row: "",
      column: "",
      showBatchNumbers: false,
      batchNumbers: [],
      previousPharmacyQuantity: 0,
      previousStoreQuantity: 0,
      branchList: [],
      branch: null,
      getRole: "",
      userRole: JSON.parse(localStorage.getItem("user")).role,
    };
    this.inputRef = React.createRef();
    this.batchNoRef = React.createRef();
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    // this.onSubmitStoreWise = this.onSubmitStoreWise.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    // this.setInputFocus = this.setInputFocus.bind(this);
    // this.setInputFocusLoad = this.setInputFocusLoad.bind(this);
  }

  // componentDidMount() {
  //   // Focus the input when the component mounts
  //   this.inputRef.current.focus();
  // }

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication inventory</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      // if (this.state.storeId == 1 || this.state.storeId == "") {
      this.props.history.push("/admin/inventoryList");
      // } else {
      // this.props.history.push("/admin/getRelatedStore");
      // }
    }, 3000);
  }

  setBarcodeRef = (el) => {
    console.log(this.barcodeRefs);
    // this.barcodeRefs.current= el;
  };

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    // this.setInputFocusLoad()
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
        if (this.batchNoRef && this.batchNoRef.current) {
          this.batchNoRef.current.focus();
        }
      }.bind(this),
      700,
    );
    const token = JSON.parse(localStorage.getItem("user"));
    this.setState({
      storeId: token.store_id || "",
      getRole: token.role || "",
    });
    this.getStoreList();
  }
  getStoreList = () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getBrachDetailsCountryCodeWise(token.country_code, obj).then((res) => {
      const branchListOptions = res.data.map((data) => {
        return {
          value: data.id,
          label: data.name,
        };
      });
      let defaultBranch = null;
      if (this.state.userRole === 1) {
        defaultBranch = branchListOptions.find(
          (branch) => branch.label === "Flash Health Pharmacy",
        );
      }
      this.setState({
        branchList: branchListOptions,
        branch: defaultBranch,
      });
    });
  };

  onChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  onSubmitStoreWise = () => {
    if (this.state.disableSubmitButton) return;

    this.setState({ disableSubmitButton: true });

    let error = false;

    // Medication validation
    if (this.state.medication === "") {
      error = true;
      this.setState({
        medicationError: (
          <small className="text-danger">Medication is required.</small>
        ),
      });
    } else {
      this.setState({ medicationError: null });
    }

    // Quantity validation
    if (!this.state.quantity || this.state.quantity.length === 0) {
      error = true;
      this.setState({
        quantityError: (
          <small className="text-danger">Quantity is required.</small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }

    if (this.state.note == "") {
      error = true;
      this.setState({
        noteError: <small className="text-danger">Note is required.</small>,
      });
    } else {
      this.setState({ noteError: null });
    }

    // Stop if validation fails
    if (error) {
      this.setState({ disableSubmitButton: false });
      return;
    }
    if (this.state.receivable_date != "") {
      const receivable_date = new Date(this.state.receivable_date);
      var receivable_dd = ("0" + receivable_date.getDate()).slice(-2);
      var receivable_mm = ("0" + (receivable_date.getMonth() + 1)).slice(-2);
      var receivable_yyyy = receivable_date.getFullYear();
      var receivable_today =
        receivable_yyyy + "-" + receivable_mm + "-" + receivable_dd;
    } else {
      var receivable_today = "";
    }

    if (this.state.expiryDate != "") {
      const date = new Date(this.state.expiryDate);
      var dd = ("0" + date.getDate()).slice(-2);
      var mm = ("0" + (date.getMonth() + 1)).slice(-2);
      var yyyy = date.getFullYear();
      var today = yyyy + "-" + mm + "-" + dd;
    } else {
      var today = "";
    }

    const batches = [
      {
        batch_no: this.state.batch_no || "",
        expiry_date: today || null,
        quantity: this.state.quantity || 0,
      },
    ];

    // API call
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    AddToInventoryStockStoreWise({
      store_id: this.state.branch ? this.state.branch.value : "",
      medication_id: this.state.medication,
      obj: obj,
      quantity: this.state.quantity,
      expiry_date: today,
      unit_price: this.state.unit_price,
      batch_no: this.state.batch_no,
      note: this.state.note,
      receivable_date: receivable_today,
      is_goods_received: this.state.is_goods_received,
      quantity_type: this.state.quantity_type,
      quantity_per_box: this.state.quantity_per_box,
      xcoord: this.state.row,
      ycoord: this.state.column,
      batches: batches,
    })
      .then((res) => {
        if (res.data.success === false) {
          this.handleClick("bl");
        } else {
          this.handleSuccess("bl");
          setTimeout(() => {
            this.setState({ disableSubmitButton: false });
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error);
        this.handleNetworkError("bl");
        setTimeout(() => {
          this.setState({ disableSubmitButton: false });
        }, 3000);
      });
  };

  onSubmit = () => {
    if (this.state.disableSubmitButton) return;
    this.setState({ disableSubmitButton: true });
    let error = false;
    if (this.state.medication == "") {
      error = true;
      this.setState({
        medicationError: (
          <small className="text-danger">Medication is required.</small>
        ),
      });
    } else {
      this.setState({ medicationError: null });
    }
    if (this.state.note == "") {
      error = true;
      this.setState({
        noteError: <small className="text-danger">Note is required.</small>,
      });
    } else {
      this.setState({ noteError: null });
    }
    // if (this.state.branch == null || this.state.branch == "") {
    //   error = true;
    //   this.setState({
    //     branchError: (
    //       <small className="text-danger">warehouse is required.</small>
    //     ),
    //   });
    // } else {
    //   this.setState({ branchError: null });
    // }

    const productCategory = String(this.state.getProductCategory || "")
      .trim()
      .toLowerCase();
    if (productCategory == "medicine" && !this.state.expiryDate) {
      error = true;
      this.setState({
        expiryDateError: (
          <small className="text-danger">Expiry date is required.</small>
        ),
      });
    } else {
      this.setState({ expiryDateError: null });
    }
    if (this.state.quantity.length == 0) {
      error = true;
      this.setState({
        quantityError: (
          <small className="text-danger">Quantity is required..</small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }

    if (this.state.medication.length == 0) {
      error = true;
      this.setState({
        medicationError: (
          <small className="text-danger">Medication is required..</small>
        ),
      });
    } else {
      this.setState({ medicationError: null });
    }

    // if (this.state.is_goods_received == "") {
    //   this.setState({
    //     is_goods_received: 0
    //   });
    // }

    // if (this.state.quantity_type == "0") {
    //   error = true;
    //   this.setState({
    //     quantity_typeError: (
    //       <small className="text-danger">Quantity Type is required.</small>
    //     ),
    //   });
    // } else {
    //   this.setState({ quantity_typeError: null });
    // }

    // if (this.state.quantity_type == 1) {
    //   if (this.state.quantity_type == 0) {
    //     console.log("quantity_type");
    //     error = true;
    //     this.setState({
    //       quantity_typeError: (
    //         <small className="text-danger">Quantity Type is required.</small>
    //       ),
    //     });
    //   } else {
    //     this.setState({ quantity_typeError: null });
    //   }
    // } else {
    //   this.setState({ quantity_per_box: "0" });
    // }
    if (error) {
      this.setState({ disableSubmitButton: false });
      return;
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      if (this.state.receivable_date != "") {
        const receivable_date = new Date(this.state.receivable_date);
        var receivable_dd = ("0" + receivable_date.getDate()).slice(-2);
        var receivable_mm = ("0" + (receivable_date.getMonth() + 1)).slice(-2);
        var receivable_yyyy = receivable_date.getFullYear();
        var receivable_today =
          receivable_yyyy + "-" + receivable_mm + "-" + receivable_dd;
      } else {
        var receivable_today = "";
      }

      if (this.state.expiryDate != "") {
        const date = new Date(this.state.expiryDate);
        var dd = ("0" + date.getDate()).slice(-2);
        var mm = ("0" + (date.getMonth() + 1)).slice(-2);
        var yyyy = date.getFullYear();
        var today = yyyy + "-" + mm + "-" + dd;
      } else {
        var today = "";
      }

      const batches = [
        {
          batch_no: this.state.batch_no,
          expiry_date: today,
          quantity: this.state.quantity,
        },
      ];
      AddInvetory(
        this.state.medication,
        this.state.quantity,
        today,
        this.state.unit_price,
        this.state.batch_no,
        this.state.note,
        receivable_today,
        this.state.is_goods_received,
        this.state.quantity_type,
        this.state.quantity_per_box,
        obj,
        batches,
        this.state.branch ? this.state.branch.value : "",
        this.state.row,
        this.state.column,
      )
        .then((res) => {
          if (res.data.success === false) {
            this.handleClick("bl");
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            setTimeout(() => {
              this.setState({ disableSubmitButton: false });
            }, 3000);
            this.setState({
              title: "",
              description: "",
              brand: "",
              size: "",
            });
          }
          // this.props.history.push('/admin/subscription');
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
          setTimeout(() => {
            this.setState({ disableSubmitButton: false });
          }, 3000);
        });
    }
  };
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), event);
      }, 500),
    });
  };
  // setInputFocus() {
  //   ReactDOM.findDOMNode(this.quantityChange).focus();
  //   this.quantityChange.focus();
  // }
  // setInputFocusLoad() {
  //   ReactDOM.findDOMNode(this.itemSelect).focus();
  //   this.itemSelect.focus();
  // }
  sendToParent = async (name, event) => {
    //this.props.searching(this.state.name);c

    if (this.state.name.length !== 0) {
      let compelte = 1;
      let pg_no = 1;
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      const store = token.store_id === null ? "" : token.store_id;
      await searchMedicationForManualGrn(this.state.name, obj).then((res) => {
        var mdata = res.data.data;

        var medicationItems = [];
        //alert("in else")
        this.setState({ medication_detail: [] });

        if (res.data.data.length > 1) {
          console.log(res.data.data, "values");
          res.data.data.map((x, i) => {
            medicationItems.push({
              value: x.id,
              label:
                x.title +
                " (" +
                x.item_code +
                ")" +
                (x.barcode != null ? " - " + x.barcode : ""),
            });
          });
          this.setState({
            medicationItems: medicationItems,
            medicineData: res.data.data,
          });
          this.inputRef.current.focus();
          this.inputRef.current.onMenuOpen();
        } else if (res.data.data.length === 1) {
          this.setState({
            medicationItems: medicationItems,
            medicineData: res.data.data,
          });
          res.data.data.find((item) => {
            this.handleSelectChange({
              value: item.id,
              label:
                item.title +
                " (" +
                item.item_code +
                ")" +
                (item.barcode != null ? " - " + item.barcode : ""),
            });
          });
          // this.setInputFocus();
          // this.setState({
          //   medicationItems: medicationItems,
          //   medicineData: res.data.data,
          // });
        }
      });
    } else {
      this.setState({ medication_detail: [], medicationItems: [] });
    }
  };

  yesterday = moment().subtract(1, "day");
  disablePastDt = (current) => {
    return current.isAfter(this.yesterday);
  };

  handleSelectChange = (value) => {
    const storeId = Number(this.state.storeId);

    this.setState(
      {
        medication: value.value,
        medicineValue: value,
        medicationError: null,
      },
      async () => {
        // if (storeId == 1 || storeId == "") {
        await this.getMedicationStoreWise(value.value, this.state.storeId);
        // }
      },
    );

    if (value) {
      console.log("this.state.medicationItems", this.state.medicineData);
      const findBatches =
        this.state.medicineData &&
        this.state.medicineData.find((item) => item.id == value.value);
      console.log("findBatches", findBatches);

      const availableQuantity =
        findBatches.store_wise_medication &&
        findBatches.store_wise_medication.reduce(
          (total, med) => total + Number(med.quantity || 0),
          0,
        );
      console.log("availableQuantity", availableQuantity);
      this.setState({
        previousQuantity: availableQuantity || 0,
        branch:
          this.state.userRole !== 1
            ? this.getUserRoleWiseBranch()
            : this.state.branch,
      });
      const unique = [
        ...new Map(
          findBatches.batches.map((item) => [item.batch_no, item]),
        ).values(),
      ];
      console.log();
      if (unique && unique && unique.length > 1) {
        this.setState({
          showBatchNumbers: true,
          batchNumbers: unique,
          previousQuantity: availableQuantity || 0,
          branch:
            this.state.userRole !== 1
              ? this.getUserRoleWiseBranch()
              : this.state.branch,
        });
      }
    }
  };

  getUserRoleWiseBranch = () => {
    switch (this.state.userRole) {
      case 11:
        const branchPharmacy = this.state.branchList.find(
          (b) => b.label === "Flash Health Pharmacy",
        );
        return branchPharmacy;
      case 17:
        const branchStore = this.state.branchList.find(
          (b) => b.label === "Flash WareHouse",
        );
        return branchStore;
      default:
        return null;
    }
  };

  handleBatchNumber = async (value) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    if (value !== "") {
      const data = await getBatchNumberByAllMedicine(obj, value);
      console.log("data", data);
      const MEdicineDetails = data.data.data.medication.medication_batches.find(
        (item) => item.batch_no === value,
      );
      console.log("MEdicineDetails", MEdicineDetails);

      const getPharmacyLevelQuantity =
        data.data.data.medication.store_wise_medication.find(
          (med) =>
            med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
        );

      const getStoreLevelQuantity =
        data.data.data.medication.store_wise_medication.find(
          (med) => med.pharmacies && med.pharmacies.name === "Flash WareHouse",
        );

      // available quantity calculation was getStoreLevelQuantity.quantity + getPharmacyLevelQuantity.quantity
      const availableQuantity =
        data.data.data.medication.store_wise_medication.reduce(
          (total, med) => total + Number(med.quantity || 0),
          0,
        );

      if (data.data.success && MEdicineDetails) {
        // if (MEdicineDetails.medication.quantity_type == "1") {
        //   this.setState({ showPerBox: true });
        // } else {
        //   this.setState({ showPerBox: false });
        // }
        const medicineOption = {
          value: data.data.data.medication.id,
          label:
            data.data.data.medication.title +
            " (" +
            data.data.data.medication.item_code +
            ")" +
            (data.data.data.medication.barcode != null
              ? " - " + data.data.data.medication.barcode
              : ""),
        };
        this.setState({
          // quantity: data.quantity,
          quantity_type: "2",
          quantity_per_box: false,
          unit_price: data.data.data.medication.unit_price || "",
          barcodeValue: data.data.data.medication.barcode || "",
          previousQuantity: Number(availableQuantity) || 0, // ✅ FIX
          previousPharmacyQuantity: getPharmacyLevelQuantity
            ? Number(getPharmacyLevelQuantity.quantity)
            : 0,
          previousStoreQuantity: getStoreLevelQuantity
            ? Number(getStoreLevelQuantity.quantity)
            : 0,
          // previousBatchQuantity: MEdicineDetails.quantity || 0,
          previousPrice: data.data.data.medication.buying_price,
          itemCode: data.data.data.medication.item_code,
          medicineValue: medicineOption,
          expiryDate: MEdicineDetails.expiry_date,
          medication: medicineOption.value,
          branch:
            this.state.userRole !== 1
              ? this.getUserRoleWiseBranch()
              : this.state.branch,
          row: data.data.data.medication.xcoord || "",
          column: data.data.data.medication.ycoord || "",
        });
      } else {
        this.setState({
          // medicineNotAvailable: true,
          // batch_no: "",
        });
      }
    }
  };

  handleBarcodeNoChange = (event) => {
    const barcode = event.target.value;
    console.log(barcode);
    console.log(barcode.length);
    if (barcode.trim()[0] == "F") {
      const self = this;

      if (self.state.typingTimeout) {
        clearTimeout(self.state.typingTimeout);
      }

      self.setState({
        name: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParent(self.state.name.trim(), event);
        }, 500),
      });
    } else {
      if (barcode.length == 7) {
        console.log("hii");
        const self = this;

        if (self.state.typingTimeout) {
          clearTimeout(self.state.typingTimeout);
        }

        self.setState({
          name: event.target.value.trim(),
          typing: false,
          typingTimeout: setTimeout(function () {
            self.sendToParent(self.state.name.trim(), event);
          }, 500),
        });
      }
    }
  };

  setInputRef = () => {
    this.inputRef.current.focus();
  };

  getMedicinDetailById = (id) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    updateMedication_old_data(id, obj).then((res) => {
      var data = res.data;
      console.log("data", data);
      console.log(res.data, "values");
      console.log(data, "<<--- data");
      if (data.quantity_type == "1") {
        this.setState({ showPerBox: true });
      } else {
        this.setState({ showPerBox: false });
      }

      this.setState({
        // quantity: data.quantity,
        quantity_type: data.quantity_type || "2",
        quantity_per_box: data.quantity_per_box,
        unit_price: data.unit_price,
        barcodeValue: data.barcode,
        previousQuantity: Number(data.total_quantity),
        previousPrice: data.unit_price,
        itemCode: data.item_code,
        expiryDate: data.expiry_date,
        getProductCategory: data.product_categories,
      });
    });
  };
  getMedicationStoreWise = async (medId, storeId) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    await getMedicaitionDataById(obj, medId, storeId).then((res) => {
      const data = res.data.data;
      if (data.quantity_type == "1") {
        this.setState({ showPerBox: true });
      } else {
        this.setState({ showPerBox: false });
      }

      console.log("data", data);
      const getPharmacyLevelQuantity = data.store_wise_medication.find(
        (med) =>
          med.pharmacies && med.pharmacies.name === "Flash Health Pharmacy",
      );

      const getStoreLevelQuantity = data.store_wise_medication.find(
        (med) => med.pharmacies && med.pharmacies.name === "Flash WareHouse",
      );
      // console.log("getStoreLevelQuantity", getStoreLevelQuantity);
      // console.log("getPharmacyLevelQuantity", getPharmacyLevelQuantity);
      this.setState({
        // quantity: data.quantity || 0,
        previousQuantity: Number(data.total_quantity) || 0, // ✅ FIX
        previousStoreQuantity: getStoreLevelQuantity
          ? Number(getStoreLevelQuantity.quantity)
          : 0, // ✅ FIX
        previousPharmacyQuantity: Number(
          getPharmacyLevelQuantity ? getPharmacyLevelQuantity.quantity : 0,
        ), // ✅ FIX
        quantity_type: data.quantity_type || "0",
        quantity_per_box: data.quantity_per_box || 0,
        unit_price: Number(data.buying_price) || 0,
        previousPrice: Number(data.buying_price) || 0,
        barcodeValue: data.barcode || "",
        itemCode: data.item_code || "",
        row: data.xcoord || "",
        column: data.ycoord || "",
        expiryDate: data.expiry_date || "",
        getProductCategory: data.product_categories || "",
      });
    });
  };

  handleDateChange = (date) => {
    this.setState({
      expiryDate: date,
      expiryDateError: null,
    });
  };

  handleReceivableDateChange = (date) => {
    this.setState({
      receivable_date: date,
    });
  };

  // is_goods_received = (e) => {
  //   var checked = e.target.checked;
  //   if (checked == false) {
  //     this.setState({
  //       is_goods_received: checked,
  //       is_goods_received: 0
  //     });
  //   }else{
  //     this.setState({ is_goods_received: checked, is_goods_received: 1 });
  //   }

  // }

  avalableQuantityOnchange(event) {
    const userData = JSON.parse(localStorage.getItem("user"));
    const role = userData.role;
    const value = event.target.value;
    let availablePharmacyQuantity = this.state.previousPharmacyQuantity;
    let availableStoreQuantity = this.state.previousStoreQuantity;
    const availableQuantity =
      Number(this.state.previousQuantity) +
      (Number(value) - Number(this.state.quantity));
    if (role === 11 || this.state.branch.label === "Flash Health Pharmacy") {
      availablePharmacyQuantity =
        Number(this.state.previousPharmacyQuantity) +
        (Number(value) - Number(this.state.quantity));
    } else if (role === 17 || this.state.branch.label === "Flash WareHouse") {
      availableStoreQuantity =
        Number(this.state.previousStoreQuantity) +
        (Number(value) - Number(this.state.quantity));
    } else {
    }

    // const prevQty = Number(this.state.previousQuantity) || 0;
    // const oldQty = Number(this.state.quantity) || 0;
    // const newQty = Number(value) || 0;
    // const availableQuantity = prevQty + (newQty - oldQty);
    this.setState({
      quantity: value,
      previousQuantity: availableQuantity,
      previousPharmacyQuantity: availablePharmacyQuantity,
      previousStoreQuantity: availableStoreQuantity,
      quantityError: null,
    });

    if (event.target.value === "") {
      this.setState({
        quantityError: (
          <small className="text-danger">quantity is required.</small>
        ),
      });
    } else {
      this.setState({ quantityError: null });
    }
  }

  unitPriceOnchange(event) {
    const value = event.target.value;
    // const buyingPrice = Number(this.state.previousPrice) + (Number(event.target.value) - this.state.unit_price)
    this.setState({
      unit_price: value,
      // previousPrice: buyingPrice,
    });
  }
  BatchNoOnchange(event) {
    const value = event.target.value;
    this.setState({
      batch_no: value,
    });
    this.handleBatchNumber(value);
    // if (value && this.inputRef.current) {
    //   setTimeout(() => {
    //     this.inputRef.current.focus();
    //   }, 0);
    // }
  }

  render() {
    const addDebitLog = <Tooltip id="addDebit">coppied</Tooltip>;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Batch No.</ControlLabel>
                          <ForwardedFormControl
                            type="text"
                            name="Batch No"
                            placeholder="Batch No"
                            style={{
                              backgroundColor: "#ffffff",
                              border: "1px solid #e3e3e3",
                              borderRadius: "4px",
                              color: "#565656",
                              padding: " 8px 12px",
                              height: "40px",
                              boxShadow: "none",
                              width: "100%",
                            }}
                            ref={this.batchNoRef}
                            // onChange={(e) => this.BatchNoOnchange(e)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                this.BatchNoOnchange(e);
                              }
                            }}
                            // value={poItem.barcode}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <ControlLabel>Batch No</ControlLabel>
                        <FormControl
                          style={{ border: "none", width: "150px" }}
                          disabled
                          value={
                            this.state.batch_no === ""
                              ? "NA"
                              : this.state.batch_no
                          }
                          type="text"
                        />
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Batch No</ControlLabel> 
                          <ForwardedFormControl
                            type="text"
                            name="Batch No"
                            placeholder="Batch No"
                            style={{
                              backgroundColor: "#ffffff",
                              border: "1px solid #e3e3e3",
                              borderRadius: "4px",
                              color: "#565656",
                              padding: " 8px 12px",
                              height: "40px",
                              boxShadow: "none",
                              width: "100%",
                            }}
                            onChange={(e) => this.BatchNoOnchange(e)}
                            value={this.state.batch_no}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <ControlLabel>Batch No</ControlLabel>
                        <FormControl
                          style={{ border: "none", width: "150px" }}
                          disabled
                          value={
                            this.state.batch_no === ""
                              ? "NA"
                              : this.state.batch_no
                          }
                          type="text"
                        />
                      </Col>
                    </Row> */}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Items</ControlLabel>
                          <div
                            onKeyUp={(e) => this.inputOnChange(e)}
                            className="Appy"
                          >
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="description"
                              ref={this.inputRef}
                              onKeyDown={(e) => {
                                console.log("e", e);
                                if (e.key === "Enter") {
                                  console.log("Enter", e.key);
                                }
                              }}
                              // ref={a => (this.itemSelect = a)}
                              value={
                                this.state.medicineValue === ""
                                  ? ""
                                  : this.state.medicineValue
                              }
                              onChange={(value) =>
                                this.handleSelectChange(value)
                              }
                              options={this.state.medicationItems}
                              placeholder="Enter Item Name or Code or Barcode"
                              noOptionsMessage={() => "Type Item Name or Code"}
                            />
                          </div>
                          {this.state.medicationError}
                        </FormGroup>
                      </Col>
                      <Col sm={5}>
                        <div style={{ marginTop: "20px", display: "flex" }}>
                          <ControlLabel>&nbsp;</ControlLabel>
                          <FormControl
                            style={{ border: "none", width: "150px" }}
                            disabled
                            value={this.state.itemCode}
                            type="text"
                          />
                          <OverlayTrigger
                            placement="top"
                            overlay={addDebitLog}
                            rootClose
                          >
                            <i
                              class="fa fa-copy"
                              style={{
                                fontSize: "24px",
                                marginLeft: "-30px",
                                marginTop: "13px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  this.state.itemCode,
                                );
                                this.setState({ coppied: true });
                              }}
                            />
                          </OverlayTrigger>
                        </div>
                      </Col>
                    </Row>
                    {this.state.userRole === 1 && (
                      <Row>
                        <Col md={6} style={{ marginBottom: "10px" }}>
                          <ControlLabel>Select Warehouse</ControlLabel>
                          <Select
                            placeholder="select warehouse"
                            options={this.state.branchList}
                            onChange={(value) => {
                              this.setState({ branch: value });
                            }}
                            value={
                              this.state.branch ||
                              this.state.branchList.find(
                                (branch) =>
                                  branch.label === "Flash Health Pharmacy",
                              ) ||
                              null
                            }
                            isClearable
                          />
                          {this.state.branchError}
                        </Col>
                      </Row>
                    )}
                    {/* <FormGroup>
                          <ControlLabel>Quantity Type</ControlLabel>

                          <div className="order_source_data">
                            <Radio
                              number="31"
                              option="1"
                              name="quantity_type"
                              onChange={(event) => this.handleQuantity_type_chnage(event)}
                              checked={this.state.quantity_type == "1"}
                              label="Quantiy Per Box"
                              // disabled={true}
                            />
                            &nbsp;
                            <Radio
                              number="32"
                              option="2"
                              name="quantity_type"
                              onChange={(event) => this.handleQuantity_type_chnage(event)}
                              checked={this.state.quantity_type == "2"}
                              label="Quantiy Per Tablet"
                              // disabled={true}
                            />

                          </div>
                          {this.state.quantity_typeError}
                        </FormGroup> */}

                    {/* {this.state.showPerBox == true &&
                          <FormGroup>
                            <ControlLabel>Quantity Per Box</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) => this.handleQuantity_per_box_chnage(event)}
                              required
                              // readOnly
                              name="quantity_per_box "
                              value={this.state.quantity_per_box || ""}
                              placeholder="Quantity Per Box"
                              // disabled={true}
                            />
                            {this.state.quantity_per_boxError}
                          </FormGroup>
                        } */}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Quantity</ControlLabel>
                          <FormControl
                            name="quantity"
                            onWheel={(e) => e.target.blur()}
                            // value={this.state.quantity}
                            onChange={(event) =>
                              this.avalableQuantityOnchange(event)
                            }
                            placeholder="Enter quantity"
                            type="number"
                            // ref={c => (this.quantityChange = c)}
                          />
                          {this.state.quantityError}
                        </FormGroup>
                      </Col>
                      {this.state.getRole === 1 && (
                        <Col md={2}>
                          <ControlLabel>Available Quantity</ControlLabel>
                          <FormControl
                            style={{ border: "none", width: "150px" }}
                            disabled
                            value={Number(this.state.previousQuantity)}
                            type="text"
                          />
                        </Col>
                      )}
                      <Col md={2}>
                        <ControlLabel>Available Pharmacy Quantity</ControlLabel>
                        <FormControl
                          style={{ border: "none", width: "150px" }}
                          disabled
                          value={Number(this.state.previousPharmacyQuantity)}
                          type="text"
                        />
                      </Col>
                      <Col md={2}>
                        <ControlLabel>Available Store Quantity</ControlLabel>
                        <FormControl
                          style={{ border: "none", width: "150px" }}
                          disabled
                          value={Number(this.state.previousStoreQuantity)}
                          type="text"
                        />
                      </Col>
                    </Row>
                    {/* <Row>
                      <Col md={6} style={{ marginBottom: "10px" }}>
                        <ControlLabel>Select Warehouse</ControlLabel>
                        <Select
                          placeholder="select warehouse"
                          options={this.state.branchList}
                          onChange={(value) => {
                            this.setState({ branch: value });
                          }}
                          value={this.state.branch}
                          isClearable
                        />
                        {this.state.branchError}
                      </Col>
                    </Row> */}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Column</ControlLabel>
                          <FormControl
                            className="form-control"
                            name="column"
                            value={this.state.column}
                            cols={3}
                            rows={2}
                            placeholder="Enter column"
                            onChange={(event) => {
                              this.setState({ column: event.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Row</ControlLabel>
                          <FormControl
                            className="form-control"
                            name="row"
                            value={this.state.row}
                            cols={3}
                            rows={2}
                            placeholder="Enter row"
                            onChange={(event) => {
                              this.setState({ row: event.target.value });
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Expiry Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            isValidDate={this.disablePastDt}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Expiry Date" }}
                            closeOnSelect={true}
                            value={this.state.expiryDate}
                            onChange={this.handleDateChange}
                          />
                          {this.state.expiryDateError}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>
                            Buying price of the stocks
                          </ControlLabel>
                          <FormControl
                            name="unit_price"
                            onWheel={(e) => e.target.blur()}
                            value={Number(this.state.unit_price)}
                            onChange={(event) => this.unitPriceOnchange(event)}
                            placeholder="Enter Buying price of the stocks"
                            type="number"
                          />
                          {/* {this.state.quantityError} */}
                        </FormGroup>
                        {/* <FormGroup>
                          <ControlLabel>Batch No</ControlLabel>
                          <FormControl
                            name="batch_no"
                            value={this.state.batch_no}
                            onChange={(event) => this.BatchNoOnchange(event)}
                            placeholder="Batch No"
                            type="text"
                          />
                          {this.state.quantityError}
                        </FormGroup> */}
                      </Col>
                      <Col md={3}>
                        <ControlLabel>Previous Buying Price</ControlLabel>
                        <FormControl
                          style={{ border: "none", width: "150px" }}
                          disabled
                          value={Number(this.state.previousPrice).toFixed(2)}
                          type="text"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Note</ControlLabel>
                          <textarea
                            className="form-control"
                            name="note"
                            value={this.state.note}
                            cols={3}
                            rows={2}
                            placeholder="Enter note"
                            onChange={(event) => {
                              this.setState({
                                note: event.target.value,
                                noteError: null,
                              });
                            }}
                          ></textarea>
                          {this.state.noteError}
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* <FormGroup>
                          <Checkbox
                            number="1"
                            checked={this.state.is_goods_received}
                            onChange={this.is_goods_received}
                            label="Is Goods Received?"
                          ></Checkbox>
                        </FormGroup> */}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Receivable Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Receivable Date" }}
                            defaultValue={this.state.receivable_date}
                            closeOnSelect={true}
                            value={this.state.receivable_date}
                            onChange={this.handleReceivableDateChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* {this.state.storeId === 1 || this.state.storeId === null ? ( */}
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                      disabled={this.state.disableSubmitButton}
                    >
                      {this.state.disableSubmitButton
                        ? "Submitting..."
                        : "Submit"}
                    </Button>
                    {/* ) : ( */}
                    {/* <Button
                        onClick={this.onSubmitStoreWise.bind(this)}
                        className="btn-color" //bsStyle="info"
                        fill
                        disabled={this.state.disableSubmitButton}
                      >
                        {this.state.disableSubmitButton
                          ? "Submitting..."
                          : "Submit"}
                      </Button> */}
                    {/* )} */}
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.medicineNotAvailable && (
          <NoMedicineAvailablePopup
            show={this.state.medicineNotAvailable}
            onHide={() => this.setState({ medicineNotAvailable: false })}
          />
        )}
        {this.state.showBatchNumbers && (
          <ShowMultipleBatchesModal
            show={this.state.showBatchNumbers}
            batchData={this.state.batchNumbers}
            onHide={(selectedBatch) => {
              if (selectedBatch && selectedBatch.batch_no) {
                this.setState({
                  batch_no: selectedBatch.batch_no,
                  expiryDate: selectedBatch.expiry_date || "",
                  itemCode: selectedBatch.item_code || "",
                  previousBatchQuantity: selectedBatch.quantity || 0,
                  showBatchNumbers: false,
                });
              } else {
                this.setState({ showBatchNumbers: false });
              }
            }}
          />
        )}
      </div>
    );
  }
}

export default addnewsubscriptionpackage;
